import { useScrollLock } from 'usehooks-ts'
import type { VideoSource } from '@velasca/types'
import { Background, Video } from './ZoomedVideo.styles'
import type { ZoomedVideoProps } from './ZoomedVideo.types'

export const ZoomedVideo = ({
  media,
  handleClose,
}: ZoomedVideoProps): JSX.Element => {
  useScrollLock()

  return (
    <Background onClick={handleClose}>
      <Video
        loop
        autoPlay
        muted
        playsInline
        controls={false}
        controlsList="nodownload"
        onContextMenu={(e) => {
          // needed to prevent video download on right click.
          e.preventDefault()

          return false
        }}
      >
        {media.sources.map(({ src, mimeType }: VideoSource) => (
          <source key={src} src={src} type={mimeType} />
        ))}
      </Video>
    </Background>
  )
}
